import { IHttpApi } from '@cian/http-api';
import {
  IGetRecommendedOffersRequest,
  TGetRecommendedOffersResponse,
  fetchGetRecommendedOffers,
} from '../repositories/monolithPython/v2/get-recommended-offers';
import {
  IGetSimilarOffersRequest,
  TGetSimilarOffersResponse,
  fetchGetSimilarOffers,
} from '../repositories/monolithPython/v2/get-similar-offers';

export interface ISimilarOfferUnderground {
  lineColor: string | null;
  text: string | null;
  type: string | null;
}

export interface ISimilarOffer {
  address: string | null;
  brand: string | null;
  category: string | null;
  id: number | null;
  label: string | null;
  photoUrl: string | null;
  title: string | null;
  totalPriceRur: number | null;
  underground: ISimilarOfferUnderground | null;
  url: string | null;
  variant: string | null;
  publishedUserId: number | null;
}

export interface ISimilarOffersResponseData {
  similarOffers: ISimilarOffer[] | null;
  withoutCompetitors: boolean | null;
  modelVersion: number | string | null;
}

export function getItemBasedSimilarOffers(
  httpApi: IHttpApi,
  parameters: IGetSimilarOffersRequest,
  subdomain: string,
): Promise<TGetSimilarOffersResponse> {
  return fetchGetSimilarOffers({ httpApi, parameters, config: { subdomain } });
}

export function getUserBasedSimilarOffers(
  httpApi: IHttpApi,
  parameters: IGetRecommendedOffersRequest,
  subdomain: string,
): Promise<TGetRecommendedOffersResponse> {
  return fetchGetRecommendedOffers({ httpApi, parameters, config: { subdomain } });
}
